<main class="app-shell">
  <header class="app-shell__header">
    <img src="/assets/clearthread-logo.png" alt="ClearThread" class="app-shell__logo" />
  </header>
  <router-outlet />
</main>
